export const envoirment = {
    baseUrl: "https://api.winkdoc.com",
    socketUrl: "wss:api.winkdoc.com",
    ticketBaseUrl: 'https://api.tickets.zimo.one'
  };
  export const ImageBaseURL = "/winkdoc-api/rest/uploads"
  export const projectId = "6548ced843f4e791d06cc2ea"
  export const RAZORPAY_KEYID = "rzp_test_cOcpuHhzVRrhQI";
  export const stripeKey = "pk_test_51PWZcDP7lcHafHCcbpmY12JvOB4vSjdTY7cEAOxzCQKQRI5mcHOgZd9R3xES0ZcfA4NbME01N2vsIUhkIZHvsMXO0036MleNAW";
